import React from 'react'
import { SolidButton } from '../../../../library/button'
import './style.scss'

const Index = ({title, description, buttonTitle, onClick}) => {
    return(
        <div className="channel-domain-status-container">
            <div className="inner-domain-status-container">
                <h3 className="status-title">{title}</h3>
                <p className="status-description">{description}</p>
                <SolidButton onClick={onClick} color="blue" title={buttonTitle}/>
            </div>
        </div>
    )
}

export default Index